import { findIndex } from 'lodash';
import {
  VISIBILITY,
  checkIfSelectionValid,
} from '@learningblocks/protocol-constants/lib/Utilities';
const NEXT_COMPONENT = 'nextComponent';
const FINAL_POINT = 'finalPoint';

// check if selected Question option correct adn update accordingly
export function submitQuestionAnswer(state, payload) {

  let key = (
    state.protocolSection.scene.hasOwnProperty("apparatus") &&
    state.protocolSection.scene.apparatus.hasOwnProperty("solutions")
  )?Object.keys(state.protocolSection.scene.apparatus.solutions[14].solutions)[0]:null

  state = {
    ...state,
    currentSection: updateSubmissionInCurrentSection(
      state.currentSection,
      payload,
      key
    ),
  };

  // Tracking specific info (we need the state after modification)

  let questionComponents = state.currentSection.components.filter((component) => component.type == "CSCQ");
  let questionIndex = findIndex(questionComponents, {id: payload.componentID});
  let optionIndex = findIndex(questionComponents[questionIndex].options, {selected: true});

  return state;
}

function updateSubmissionInCurrentSection(currentSection, payload, key) {
  return {
    ...currentSection,
    components: updateSubmissionInComponents(
      currentSection.components,
      payload,
      key
    ),
  };
}

function updateSubmissionInComponents(components, payload, key) {
  const {newcomponents} = components.reduce(
    (acc, component) => {
      // updating submitted CSCQ component
      if (component.id === payload.componentID && component.options) {
        component = updateOptionsComponent(component);
        if (component.hasOwnProperty(NEXT_COMPONENT)) {
          acc.forward = {
            complete: component.complete,
            nextComponent: component.nextComponent,
          };
        }
      }

      if (component.id === payload.componentID && component.groupedOptions1 && component.groupedOptions2) {
        component = updateGroupedOptionsComponent(component, key);
        if (component.hasOwnProperty(NEXT_COMPONENT)) {
          acc.forward = {
            complete: component.complete,
            nextComponent: component.nextComponent,
          };
        }
      }

      // updating submitted CSCQ_COLOR component
      if (component.id === payload.componentID && component.typedOptions) {
        component = updateTypedOptionsComponent(component);
        if (component.hasOwnProperty(NEXT_COMPONENT)) {
          acc.forward = {
            complete: component.complete,
            nextComponent: component.nextComponent,
          };
        }
      }

      // updating finalPoint to display rest of contents in section
      if (component.hasOwnProperty(FINAL_POINT) && component.complete) {
        component = {...component, finalPoint: false};
      }

      if (
        acc.forward &&
        acc.forward.complete &&
        acc.forward.nextComponent === component.id
      ) {
        // updating forward component and setting its visibility
        component = {...component, visibility: VISIBILITY.VISIBLE};
        acc.forward = null;
      }

      acc.newcomponents = [...acc.newcomponents, component];
      return acc;
    },
    {
      forward: null,
      newcomponents: [],
    }
  );
  return newcomponents;
}

function updateOptionsComponent(component) {
  if (checkIfSelectionValid(component)) {
    component.complete = updateCSCQComplete(
      component.options,
      component.answerId
    );
    component.options = component.options.map(updateSelectedOption);
    if (component.totalAttempts !== -10) {
      component.totalAttempts -= 1;
    }
  }
  return component;
}

function updateGroupedOptionsComponent(component, key) {
  if (checkIfSelectionValid(component)) {
    let group1selected = component.groupedOptions1.reduce((selected, option) => {
      if (option.selected && (!option.disabled || component.answerId[key][0] == option.id)) {
        selected.push(option.id);
      }
      return selected;
    }, []);

    let group2selected = component.groupedOptions2.reduce((selected, option) => {
      if (option.selected && (!option.disabled || component.answerId[key][1] == option.id)) {
        selected.push(option.id);
      }
      return selected;
    }, []);

    //component.lastSubmission = [...group1selected, ...group2selected];
    component.lastSubmission = []
    if(component.latestSelections.groupedOptions1 !== null){
        component.lastSubmission.push(component.latestSelections.groupedOptions1)
    }
    if(component.latestSelections.groupedOptions2 !== null){
        component.lastSubmission.push(component.latestSelections.groupedOptions2)
    }

    component.complete = updateCSCQComplete(
      [...component.groupedOptions1, ...component.groupedOptions2],
      component.answerId[key]
    );
    component.groupedOptions1 = component.groupedOptions1.map(updateSelectedOption);
    component.groupedOptions2 = component.groupedOptions2.map(updateSelectedOption);
    if (component.totalAttempts !== -10) {
      component.totalAttempts -= 1;
    }
  }
  return component;
}

function updateTypedOptionsComponent(component) {
  if (checkIfSelectionValid(component)) {
    component.complete = updateCSCQComplete(
      component.typedOptions,
      component.answerId
    );
    component.typedOptions = component.typedOptions.map(updateSelectedOption);
    if (component.totalAttempts !== -10) {
      component.totalAttempts -= 1;
    }
  }
  return component;
}

function updateSelectedOption(option) {
  if (option.selected === true) {
    option.disabled = true;
  }
  return {...option};
}

const updateCSCQComplete = (options, answerId) => {
  const selectedOptions = options.reduce((selected, option) => {
    if (option.selected && !option.disabled) {
      selected.push(option.id);
    }
    return selected;
  }, []);
  return selectedOptions.includes(answerId);
};
